import { AuthForm } from '@components/auth'

export const AuthPage = () => {
  return <AuthForm />
}
